<div class="absolute inset-0 flex min-w-0 flex-col overflow-hidden">
    <mat-drawer-container class="bg-card h-full flex-auto dark:bg-transparent">
        <!-- Drawer -->
        <mat-drawer
            class="w-full dark:bg-gray-900 md:w-6/12"
            [mode]="'side'"
            [opened]="false"
            [position]="'end'"
            [disableClose]="false"
            #matDrawer
        >
            <vista-archivo [archivo]="archivoSeleccionado" (closeDrawer)="closeDrawer()"></vista-archivo>
        </mat-drawer>
        <mat-drawer-content class="flex flex-col">
            <div class="flex-auto w-full  bg-white dark:bg-inherit mx-auto py-5  px-12">
                <!--Identificador de Tarea-->
                <div class="flex flex-row items-center border-b w-full md:w-8/12">
                    <arrow-back></arrow-back>
                    <div class="flex flex-1 justify-between mb-2" >
                        <div class="flex">
                             <div class="bg-gray-200 border px-4 py-2 text-xs font-bold"> {{this.TaskDetails.tipoTarea.descripcion | titlecase}}: </div>
                            <div class="border bg-gray-100 px-4  py-2 text-xs font-semibold">{{this.TaskDetails.tareaUuid}}</div>
                        </div>

                        @if(!mostrarBoton){
                            <mat-icon [matMenuTriggerFor]="menu">build_circle</mat-icon>
                            
                            <mat-menu #menu="matMenu">
                                @if(this.TaskDetails.tipoTarea.tipologiaId === tareaTipoGestion){
                                    <button mat-menu-item (click)="completarGestion()"
                                        [disabled]="TaskDetails.estadoTarea.tipologiaId === estadoGestionCompletada">
                                        Completar Gestión (Asociado a Bienes Culturales)
                                    </button>
                                    <button mat-menu-item (click)="completarGestionSinAsociarBien()"
                                        [disabled]="TaskDetails.estadoTarea.tipologiaId === estadoGestionCompletada">
                                        Completar Gestión a partir de un Documento Oficial
                                    </button>
                                }
                                <button mat-menu-item
                                    [disabled]="TaskDetails.estadoTarea.tipologiaId === estadoGestionCompletada 
                                        || TaskDetails.estadoTarea.tipologiaId=== tipologiaIdRechazada
                                        || TaskDetails.estadoTarea.tipologiaId === esdatogestionNoCompletada"
                                    (click)="duplicarGestion()">
                                    Iniciar Nueva Gestión a partir de estos datos
                                </button> 
                            </mat-menu>
                        }

                    </div>
                                 
                </div>
            
                <!--Detalle de la tarea-->
            
                <div class="w-full flex  flex-col md:flex-row gap-3">
            
                    <!-- Task Info-->
                    <div class="w-full flex-col  pt-6 px-1 pb-2 isDrawerOpen" id="task-details"
                        [ngClass]="{
                            'w-full': (isDrawerOpen$ | async),
                            'md:w-8/12': !(isDrawerOpen$ | async)
                        }">
                        
                        <div class="flex flex-row items-center gap-2 justify-between">
                            <div class="flex flex-row items-center gap-2">   
                                <form-type-widget [clasificacion]="this.TaskDetails.clasificacion"></form-type-widget>
                                <h1 class="font-bold text-xl"> {{this.TaskDetails.nombreTarea | titlecase }}</h1>
                            </div>
                            

                            @if (mostrarBoton) {
                                <button mat-raised-button color="primary" (click)="aprobarSolicitud()">Aprobar Solicitud</button>
                            }
                             
                            </div>
            
                        <div class="w-full info-details">
                            <!--Task Info-->
                            <task-info ></task-info>
                        </div>
            
                        <div class="w-full p-0 ">

                            @if(TaskDetails.tipoTarea.tipologiaId===tareaTipoSolicitud){
                                <div class="w-full flex justify-end">
                                    <button matButton [matMenuTriggerFor]="menu">
                                        <mat-icon>build_circle</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item (click)="descargarFormularioSolicitud()">
                                            <mat-icon>download</mat-icon>
                                            Formulario de solicitud V.A
                                        </button>
                                        <button mat-menu-item (click)="generarExpediente()">
                                            <mat-icon>print</mat-icon>
                                            Generar Expediente V.A
                                        </button>
                                        <button mat-menu-item (click)="descargarZip()">
                                            <mat-icon>folder_zip</mat-icon>
                                            Descargar zip V.A
                                        </button>
                                    </mat-menu>
                                </div>
                            }

                            <!--tabs-->
                            <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
                                <mat-tab label="Detalle de Solicitud">
                                    
                                    <ng-template matTabContent>
                                        <detalle-solicitud-va [solicitud]="this.TaskDetails"></detalle-solicitud-va>
                                    </ng-template>
            
                                </mat-tab>
                                <mat-tab label="Archivos">
                                    <ng-template matTabContent>
                                        @if(this.TaskDetails.tipoTarea.tipologiaId != this.tareaTipoSolicitud){
                                            <div class="w-full flex justify-end">
                                                <cargar-archivos [Uuid]="this.TaskDetails.tareaUuid" class="w-full md:w-auto"></cargar-archivos>
                                            </div>
                                        }
                                       <archivos-subidos (abrirDrawer)="abrirDrawer($event)" [tipoTarea]="this.TaskDetails.tipoTarea.tipologiaId"></archivos-subidos>
                                    </ng-template>
                                </mat-tab>
                                <mat-tab label="Actividad">
            
                                    <ng-template matTabContent>
                                        <div class="overflow-x-auto">
                                            <actividad-tarea></actividad-tarea>
                                        </div>
                                    </ng-template>
                                </mat-tab>
                                
                                <mat-tab label="Elementos Vinculados">
        
                                    <ng-template matTabContent>
                                        <div class="overflow-x-auto">
                                            <elementos-vinculados 
                                                [elementosVinculados]="elementosVinculados$ | async"
                                                [link]="linkElementoVinculado"
                                                ></elementos-vinculados>
                                        </div>
                                    </ng-template>
                                </mat-tab>
                                
                            </mat-tab-group>
                    
                        </div>
                        
                    </div>
            
            
                    <!-- Task Comments-->
                    @if(!(isDrawerOpen$ | async)){
                        <div class="w-full md:w-4/12 py-4 px-2 border-l" id="comments">
                            <comentarios [entityUuid]="this.TaskDetails.tareaUuid"></comentarios>
                        </div>
                    }
                        
                    
            
            
                </div>
            
            
            </div>
        </mat-drawer-content>

    </mat-drawer-container>
</div>

